import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'unsupportedChartType'
	| 'supportedChartTypes'
	| 'chartRenderError'
	| 'chartRenderErrorDetails';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		unsupportedChartType: {
			id: 'ai-mate.common.ui.chart-error.unsupported-chart-type',
			defaultMessage: 'Unsupported Chart Type: "{chartType}"',
			description: 'Error message shown when an invalid chart type is provided',
		},
		supportedChartTypes: {
			id: 'ai-mate.common.ui.chart-error.supported-chart-types',
			defaultMessage: 'Supported types: {supportedTypes}',
			description: 'Message listing the supported chart types',
		},
		chartRenderError: {
			id: 'ai-mate.common.ui.chart-error.render-error',
			defaultMessage: 'Failed to render chart',
			description: 'Error message displayed when chart fails to render due to React error',
		},
		chartRenderErrorDetails: {
			id: 'ai-mate.common.ui.chart-error.render-error-details',
			defaultMessage: 'An unexpected error occurred while rendering the chart.',
			description: 'Detailed error message displayed when chart fails to render due to React error',
		},
	});

export default message;
